import * as React from 'react';
import {
	ChipField,
	Datagrid,
	ImageField,
	ListProps,
	ReferenceArrayField,
	ReferenceField,
	TextField,
	SingleFieldList
} from 'react-admin';
import './RecipeDatagrid.scss';
import { TranslateField } from '../components/TranslateField';

export const RecipeDatagrid = (props: ListProps): React.ReactElement => {
	return (
		<Datagrid rowClick="edit" className="recipes-table" optimized
		          hasBulkActions={true}
		          rowStyle={(row: any) => ({ borderRightColor: row._readAt ? '#49d18c' : '#bbbbbb' })}>
			<TextField source="id" label="#"/><ImageField source="imageUrl" label="IMAGE"/><TextField source="title"
			                                                                                          label="TITLE"/>
			{/*<NumberField source="carbs" label="CARBS"/>*/}
			{/*<NumberField source="proteins" label="PROTEINS"/>*/}
			<TextField source="description" label="DESCRIPTION"/>
			<ReferenceField source="categoryId" reference="recipe-categories" label="CATEGORY">
				<TextField source="name"/>
			</ReferenceField>
			<ReferenceArrayField source="tagsIds" reference="tags" label="TAGS">
				<SingleFieldList>
					<ChipField label="TAGS" source="title"/>
				</SingleFieldList>
			</ReferenceArrayField>
			<TranslateField source="language" label="LANGUAGE"/>
		</Datagrid>
	);
};
